import styled from 'styled-components';

const Wrapper = styled.div`
	position: relative;
	.img-container {
		width: 100%;
		height: 365px;
		background: #f6f6f6;
		position: relative;
		img {
			position: absolute;
			left: 30%;
			bottom: -83px;
			transform: translateX(-50%);
			width: 600px;
		}
		.setup-btn {
			position: absolute;
			right: 10%;
			top: 70px;
			width: 260px;
			text-align: center;
			.ant-btn {
				font-size: 28px;
				height: auto;
				margin-bottom: 8px;
			}
		}
	}
	.info-container {
		padding-top: 100px;
		padding-left: 10%;
		text-align: left;
		h2 {
			font-size: 35px;
		}
		.ant-btn {
			margin-top: 22px;
			font-size: 48px;
			height: auto;
		}
		p {
			margin: 0;
			line-height: 1.6;
			color: #000;
			b {
				padding-right: 4px;
			}
		}
	}

	&.isNew {
		.img-container {
			img {
				left: 50%;
			}
		}
		.info-container {
			width: 610px;
			margin: auto;
			padding-top: 100px;
			text-align: center;
			h2 {
				font-size: 28px;
			}
			.ant-btn {
				margin-top: 22px;
				font-size: 48px;
				height: auto;
			}
		}
	}
	@media (max-width: 1200px) {
		.info-container {
			h2 {
				font-size: 24px;
			}
		}
	}
`;

export const ExchangeList = styled.div`
	width: 45px;
	height: Calc(100vh - 40px);
	background-color: #393939;
	position: fixed;
	top: 40px;
	left: 0;
	overflow: auto;
	a {
		display: block;
	}
	.new-exchange {
		font-size: 44px;
		line-height: 45px;
		text-align: center;
		color: #fff;
		text-decoration: none;
	}
	* {
		width: 100%;
	}
	@media (max-width: 1200px) {
		position: static;
		flex: none;
		width: 100%;
		height: 45px;
		white-space: nowrap;
		a {
			width: 45px;
			height: 45px;
			display: inline-block;
			vertical-align: top;
		}
	}
`;

export default Wrapper;
